export const ds_TilesBlock_Entry = `
    fragment ds_TilesBlock_Entry on ds_TilesBlock_Entry {
        id
        canonicalUid
        tiles_ColorPalette
        tiles_ColorTheme
        tiles_TopSpacing
        tiles_ContainerWidth
        tiles_FullWidthBackground

        tiles_TileFormat
        tiles_DividerLines

        tiles_TileItems {
            ... on ds_TilesItem_Entry {
                canonicalUid
                tileItem_ImageType
                tileItem_Heading
                tileItem_Subheading
                tileItem_TextOnHover
                tileItem_Image {
                    url @transform(width: 500, height: 500)
                    alt
                    focalPoint
                }
                tileItem_Link {
                    text: linkText
                    target
                    target
                    url
                    ariaLabel
                }
                tileItem_TextPosition
                tileItem_TextSize
                tileItem_ApplyFillToTile
                tileItem_BorderAroundTile
                tileItem_ColorTheme
                tileItem_ColorPalette
            }
        }
    }
`
